<template>
  <!-- HOME -->
  <div class="cavani_tm_section animated" id="home">
    <div class="cavani_tm_home">
      <div class="content">
        <h3 class="name">11ª Mostra de Iniciação Científica no Pantanal</h3>
        <span class="line"></span>
        <h3 class="job">
          <span class="cd-headline clip"> <!-- ANIMATE TEXT VALUES: zoom, rotate-1, letters type, letters rotate-2, loading-bar, slide, clip, letters rotate-3, letters scale, push,  -->
            <span class="blc" style="margin-right: 5px">Inscreva seu projeto </span>
            <span class="cd-words-wrapper">
              <b class="is-visible"> criativo</b>
              <b> inovador</b>
              <b> espetacular</b>
              <b> disruptivo</b>
              <b> moderno</b>
              <b> incrível</b>
              <b> moderno</b>
              <b> revolucionário</b>
              <b> tecnológico</b>
              <b> extraordinário</b>
              <b> fascinante</b>
            </span>
          </span>
        </h3>
        <p style="margin-bottom: 10px;" v-if="!this.$page.props.configs.inscricoes_finalizadas"><strong>Pré-inscrições até {{this.$page.props.configs.termino_inscricao}}</strong></p>
        <p style="margin-bottom: 10px;" v-else>
          Atenção! Submissão de Resumo até <strong>{{this.$page.props.configs.data_resumo}}</strong> e Pôster até <strong>{{this.$page.props.configs.data_poster}}</strong>
        </p>
        <div class="cavani_tm_button transition_link">
          <a href="/app/" target="_blank" class="color-mostra">Acesse o Sistema</a>
        </div>
      </div>
    </div>
  </div>
  <!-- HOME -->
</template>

<script>
export default {

}
</script>
